import { defineMessages } from "react-intl";

// Ids keep the createEditActivityModal.* prefix they had before this component was extracted from
// CreateActivityModal: renaming a message id drops its five translations.
const messages = defineMessages({
  checkInTypesMessage: {
    id: "createEditActivityModal.field.activityType.checkInTypes.message",
    defaultMessage: "Some activity types may be disabled for Check-In activities",
    description: "Message for the CheckIn Activity Types while editing CheckIn Activity",
  },
  emptyTextForWithSkippedUsers: {
    id: "createEditActivityModal.field.note.emptyTextForWithSkippedUsers",
    defaultMessage:
      "Only users that have view or edit access to either the association or the activity will receive a notification",
    description:
      "Message for the Activity Note mention dropdown when some disabled users are skipped",
  },
  placeholder: {
    id: "createEditActivityModal.field.activityType.placeholder",
    defaultMessage: "Select",
    description: "Placeholder for the Activity Type field on the Create Activity modal",
  },
  teamsRequired: {
    id: "createEditActivityModal.field.visibility.teamsRequired",
    defaultMessage: "Please select team",
    description: "Visibility field teams required message in create edit activity modal",
  },
  visibility: {
    id: "createEditActivityModal.field.visibility",
    defaultMessage: "Visible to",
    description: "Visibility field label in Create create edit activity modal",
  },
});

export default messages;
